import React from 'react';
import UserSelector from '../../../components/shared/UserSelector';
import { TransactionEventType } from '../api/types';

interface User {
  id: string;
  name: string;
}

interface FiltersProps {
  selected: TransactionEventType | null;
  onChange: (f: TransactionEventType | null) => void;
  labels: {
    all: string;
    deposits: string;
    eventCharges: string;
    charges: string;
  };
  isAdmin?: boolean;
  users?: User[];
  selectedUserId?: string | null;
  onUserIdChange?: (userId: string | null) => void;
  userFilterPlaceholder?: string;
}

const Filters: React.FC<FiltersProps> = ({
  selected,
  onChange,
  labels,
  isAdmin = false,
  users = [],
  selectedUserId = null,
  onUserIdChange,
  userFilterPlaceholder,
}) => {
  const btn = (active: boolean) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
      active
        ? 'bg-blue-600 text-white'
        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
    }`;

  // Add "All users" option at the beginning of the list
  const usersWithAllOption = React.useMemo(() => {
    if (!isAdmin || users.length === 0 || !onUserIdChange) return [];
    const allUsersOption: User = {
      id: '',
      name: userFilterPlaceholder || 'All users',
    };
    return [allUsersOption, ...users];
  }, [isAdmin, users, onUserIdChange, userFilterPlaceholder]);

  return (
    <div className="space-y-4 mb-6">
      {isAdmin && users.length > 0 && onUserIdChange && (
        <div className="max-w-xs">
          <UserSelector
            users={usersWithAllOption}
            value={selectedUserId || ''}
            onChange={(userId) => onUserIdChange(userId === '' ? null : userId)}
            placeholder={userFilterPlaceholder || 'All users'}
          />
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <button
          className={btn(selected === null)}
          onClick={() => onChange(null)}
        >
          {labels.all}
        </button>
        <button
          className={btn(selected === TransactionEventType.Deposit)}
          onClick={() => onChange(TransactionEventType.Deposit)}
        >
          {labels.deposits}
        </button>
        <button
          className={btn(selected === TransactionEventType.SelfCharge)}
          onClick={() => onChange(TransactionEventType.SelfCharge)}
        >
          {labels.charges}
        </button>
        <button
          className={btn(selected === TransactionEventType.EventCharge)}
          onClick={() => onChange(TransactionEventType.EventCharge)}
        >
          {labels.eventCharges}
        </button>
      </div>
    </div>
  );
};

export default Filters;
